'use strict';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const angular = require('angular');

function maskFactory(maskDefinition) {
  return function MaskDirective() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ctrl) {
        ctrl.$formatters.push(function formatter(value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }

          var cleanValue = maskDefinition.clearValue(value.toString());
          return maskDefinition.format(cleanValue);
        });

        ctrl.$parsers.push(function parser(value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }

          var cleanValue = maskDefinition.clearValue(value.toString());
          var formattedValue = maskDefinition.format(cleanValue);

          if (ctrl.$viewValue !== formattedValue) {
            ctrl.$setViewValue(formattedValue);
            ctrl.$render();
          }

          if (angular.isUndefined(maskDefinition.getModelValue)) {
            return cleanValue;
          }

          var actualModelType = typeof ctrl.$modelValue;
          return maskDefinition.getModelValue(formattedValue, actualModelType);
        });

        angular.forEach(maskDefinition.validations, function(
          validatorFn,
          validationErrorKey
        ) {
          ctrl.$validators[validationErrorKey] = function validator(
            modelValue,
            viewValue
          ) {
            return (
              ctrl.$isEmpty(modelValue) || validatorFn(modelValue, viewValue)
            );
          };
        });
      }
    };
  };
}

function validateCuit(cuit) {
  var mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  var total = 0;

  for (var i = 0; i < mult.length; i++) {
    total += parseInt(cuit[i]) * mult[i];
  }

  var mod = total % 11;

  var digito = mod == 0 ? 0 : mod == 1 ? 9 : 11 - mod;

  return digito == parseInt(cuit[10]);
}

// eslint-disable-next-line @typescript-eslint/no-var-requires
var StringMask = require('string-mask');

var cuitMask = new StringMask('00-00000000-0');

module.exports = maskFactory({
  clearValue: function(rawValue) {
    return rawValue.toString().replace(/[^0-9]/g, '');
  },
  format: function(cleanValue) {
    var formattedValue = cuitMask.apply(cleanValue);
    return formattedValue.trim().replace(/[^0-9]$/, '');
  },
  validations: {
    cuitNumber: function(value) {
      return validateCuit(value);
    }
  }
});
